/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Footer_TaglineInputs */

const en_home_footer_tagline = /** @type {(inputs: Home_Footer_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comprehensive travel protection, support, and wellness resources for Canadians who travel. Trusted since 1989.`)
};

const fr_home_footer_tagline = /** @type {(inputs: Home_Footer_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Protection voyage complète, soutien et ressources de bien-être pour les Canadiens qui voyagent. Fiables depuis 1989.`)
};

/**
* | output |
* | --- |
* | "Comprehensive travel protection, support, and wellness resources for Canadians who travel. Trusted since 1989." |
*
* @param {Home_Footer_TaglineInputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const home_footer_tagline = /** @type {((inputs?: Home_Footer_TaglineInputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Footer_TaglineInputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_home_footer_tagline(inputs)
	return fr_home_footer_tagline(inputs)
});